const SNOOZE = 14 * 86_400_000;
const KEY = 'install-dismissed';

// Which install popup this browser can use: the iOS sheet (real Safari only, because only
// Safari can add to the Home Screen), the Android dialog, or none. An iPad can pose as a Mac.
export function installTarget({ userAgent: ua, maxTouchPoints = 0 }) {
  if (/Android/.test(ua)) return 'android';
  const ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1);
  const safari = /Version\/[\d.]+/.test(ua) && /Safari\//.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|GSA\/|DuckDuckGo/.test(ua);
  return ios && safari ? 'ios' : null;
}

// A browser that refuses storage (or `null`) means the popup may simply come back sooner.
export function dismissedRecently(storage, now = Date.now()) {
  try { return now - Number(storage.getItem(KEY)) < SNOOZE; } catch { return false; }
}

export function dismiss(storage, now = Date.now()) {
  try { storage.setItem(KEY, String(now)); } catch { /* see dismissedRecently */ }
}
